import React, { useState } from 'react'
import Header from '../header'
import Footer from '../footer'
import Steper from './components/steper'
import { useSelector } from 'react-redux'
import { langSelector } from '../../store/langSlice'
import CustomButton from '../../components/customButton'
import getEnvironement, { getLang } from '../../environnement'
import { useLocation } from 'react-router-dom'
import axios from 'axios'
import CustomBackdrop from '../../components/backdrop'
import ConfirmDialog from './components/confirmDialog'

export default function ConfirmationPresence() {
  const lang = useSelector(langSelector);
  const location = useLocation();

  const [localState] = useState(location.state || null);
  const [confirmedPresence, setConfirmedPresence] = useState('');
  const [openBackdrop, setOpenBackdrop] = useState(false);
  const [openConfirmDialign, setOpenConfirmDialog] = useState(false);
  
  const confirmationDemandeInfo = `${getLang(lang).reservationSalle.votreDemandeReservationSalle} ${localState?.reservation.date_reservation} ${getLang(lang).reservationSalle.demandeAccepted}`;

  async function confirmerPresence(confirmed) {
    const url = `${getEnvironement().API_URL}/confirmerPresence`;
    const data = {
      cin: localState.reservation.cin,
      numeroDemande: localState.reservation.numero_demande,
      confirmed
    };
    const config = {
      headers: {
        'Content-Type': 'application/json',
      },
    }
    setConfirmedPresence(confirmed);
    setOpenBackdrop(true);
    await axios.post(url, data, config)
      .then(() => {
        setTimeout(() => {
          setOpenBackdrop(false);
        }, 1000)
      })
      .then(() => setOpenConfirmDialog(true))
      .catch(() => {setOpenBackdrop(false);});
  }

  return (
    <div>
      <CustomBackdrop open={openBackdrop} setOpen={setOpenBackdrop} />
      <ConfirmDialog
        open={openConfirmDialign}
        handleClose={() => setOpenConfirmDialog(false)}
        confirmed={confirmedPresence}
      />
      <Header />
      <div className='3xl:flex 3xl:justify-center' style={{transform: lang === 'ar' ? 'scaleX(-1)' : 'none'}}>
        <div className='3xl:w-[1200px] mx-10'>
          <Steper step={3}/>
          <div className='w-full border-dashed border-4 border-primary rounded-[30px] p-5 mb-6'>
            <p className='font-inter text-primary font-medium text-2xl sm:text-3xl text-center' style={{transform: lang === 'ar' ? 'scaleX(-1)' : 'none', direction: lang === 'ar' ? 'rtl' : 'ltr'}}>{confirmationDemandeInfo}</p>
          </div>
          <div className='grid grid-cols-2 gap-2'>
            <CustomButton
              value={getLang(lang).reservationSalle.annulerDemande}
              handelClick={() => confirmerPresence(false)}
              outlined
            />
            <CustomButton
              value={getLang(lang).reservationSalle.confirmerPresence}
              handelClick={() => confirmerPresence(true)}
            />
          </div>
          
        </div>
      </div>
      <Footer />
    </div>
  )
}
